import Pricing from '../../../components/templates/Pricing/Pricing';
import React, { Component } from 'react';
import { withLanguageContext } from '../../../utils/LanguageContext';
import './styles.css';

/**
 * Description
 *
 * @typedef {Object} Props
 * @typedef {Object} content
 *
 * @augments {Component<>}
 */

class PricingView extends Component {
	render () {
		const { content } = this.props;
		return <Pricing content={content} />;
	}
}
export default withLanguageContext(PricingView);



// WEBPACK FOOTER //
// ./src/components/views/PricingView/PricingView.js